import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Col } from "reactstrap";
import SectionCard from "@dhn/components/molecules/section-card";

/**
 * Contenedor principal de las pantallas de consultorio: columna con el
 * espaciado del layout y SectionCard con el título de la pantalla.
 *
 * <DoctorsOfficePage icon="fa-calendar" title="Agenda">...</DoctorsOfficePage>
 */
export default function DoctorsOfficePage({ children, className, ...sectionProps }) {
  return (
    <Col sm={12} className="pl-4 pt-3">
      <SectionCard className={classnames("mb-2", className)} {...sectionProps}>
        {children}
      </SectionCard>
    </Col>
  );
}

DoctorsOfficePage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
